/**
 * A barra de progresso do curso.
 *
 * Mora aqui, e não em `@mgdlead/ui`, porque só os treinamentos têm progresso — componente
 * no design system com um consumidor só é peso sem contrapartida.
 *
 * Duas decisões que valem o comentário:
 *
 *  - **o rótulo em texto vem SEMPRE junto** ("3 de 12 aulas"). Barra sozinha é cor como
 *    único indicador, que o DESIGN_SYSTEM proíbe (seção 12) e que leitor de tela não lê;
 *  - **`rounded-sm`, não `rounded-full`**: pílula é anti-padrão declarado deste produto.
 *
 * O `role="progressbar"` com `aria-valuenow` é o que torna o número afirmável no teste sem
 * depender de pixel.
 */
import { cn } from '@mgdlead/ui';

export interface ProgressBarProps {
  completed: number;
  total: number;
  /** O texto que acompanha a barra — vem de `progressLabel`, nunca montado aqui. */
  label: string;
  percent: number;
  className?: string;
}

export function ProgressBar({ completed, total, label, percent, className }: ProgressBarProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={completed}
        aria-valuetext={label}
        className="h-1.5 w-full overflow-hidden rounded-sm bg-muted"
      >
        <div
          className="h-full rounded-sm bg-primary transition-[width] duration-[var(--duration-micro)]"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-xs tabular-nums text-muted-foreground">{label}</p>
    </div>
  );
}
